import React, { useState } from "react";
import "../App.css";

const HumidityConversion = () => {
  // 初始化9行数据（第一行为表头，实际数据行8行）
  const [dataRows, setDataRows] = useState(
    Array(9).fill().map(() => ({
      wetValue: "",
      humidity: ""
    }))
  );

  // 处理输入值变化
  const handleInputChange = (index, field, value) => {
    const newDataRows = [...dataRows];
    newDataRows[index][field] = value;
    setDataRows(newDataRows);
  };

  // 计算干基值
  const calculateDryValue = (row) => {
    if (row.wetValue === "" || row.humidity === "") {
      return "";
    }
    
    const wetValue = parseFloat(row.wetValue);
    const humidity = parseFloat(row.humidity);
    
    // 湿度应该是0-100之间的值（表示百分比）
    if (isNaN(wetValue) || isNaN(humidity) || humidity > 100 || humidity < 0) {
      return "";
    }
    
    const dryValue = wetValue / (1 - humidity/100);
    return dryValue.toFixed(4);
  };

  return (
    <div style={{ padding: 24, maxWidth: 1200, margin: "0 auto" }}>
      <h2 style={{ marginBottom: 24 }}>干湿基转换计算器</h2>
      
      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', background: '#fff', borderCollapse: 'collapse', marginBottom: 24 }} border={1}>
          <thead>
            <tr style={{ background: '#f9fafe' }}>
              <th style={{ width: 60 }}>序号</th>
              <th style={{ width: 120 }}>湿基值</th>
              <th style={{ width: 120 }}>湿度</th>
              <th style={{ width: 120 }}>干基值</th>
            </tr>
          </thead>
          <tbody>
            {dataRows.map((row, index) => (
              <tr key={index}>
                <td style={{ textAlign: 'center' }}>{index + 1}</td>
                <td>
                  <input
                    type="number"
                    step="any"
                    value={row.wetValue}
                    onChange={(e) => handleInputChange(index, 'wetValue', e.target.value)}
                    style={{ width: '90%', borderRadius: 8, padding: 5 }}
                    placeholder="请输入湿基值"
                  />
                </td>
                <td>
                  <input
                    type="number"
                    step="any"
                    min="0"
                    max="100"
                    value={row.humidity}
                    onChange={(e) => handleInputChange(index, 'humidity', e.target.value)}
                    style={{ width: '90%', borderRadius: 8, padding: 5 }}
                    placeholder="0-100之间"
                  />
                </td>
                <td style={{ textAlign: 'center' }}>
                  {calculateDryValue(row)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      <div style={{ background: '#f9fafe', borderRadius: 10, padding: 20, marginTop: 16, fontSize: 16, boxShadow: '0 2px 8px #e5e9f2' }}>
        <h3>计算说明</h3>
        <p><b>计算公式：</b>干基值 = 湿基值 / (1 - 湿度/100)</p>
        <p><b>使用方法：</b>在湿基值和湿度列输入相应数值，干基值将自动计算得出</p>
        <p><b>注意事项：</b>湿度值应在0-100之间（如30%湿度应输入30）</p>
      </div>
    </div>
  );
};

export default HumidityConversion;